import { ArrayField } from './ArrayField';
import { ImageField } from './ImageField';
import { HiddenArrayField } from './HiddenArrayField';
import { CategoryListManagerField } from './CategoryListManager/CategoryListManagerField';
import { AppLinksField } from './AppLinksField';
import { ServiceListManagerField } from './ServiceListManager/ServiceListManagerField';
import { ShortcutsPickerField } from './ShortcutsPickerField';

export const fields = {
  ArrayField,
  appLinks: AppLinksField,
  categoryListManager: CategoryListManagerField,
  hiddenArray: HiddenArrayField,
  imageField: ImageField,
  serviceListManager: ServiceListManagerField,
  shortcutsPicker: ShortcutsPickerField,
};
